import { Tag } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { ReviewEntryQuestion } from '../../types/reviewEntryQuestion'
import { hasThirdPartyQuestion } from '../../utils/reviewEntryThirdPartyQuestion'
import * as Styled from './styles'

interface ReviewEntriesSupplierCellProps {
  questions: ReviewEntryQuestion[]
  supplierName?: string
}

const DEFAULT_NULL_REPLACEMENT_VALUE = '-'

export const ReviewEntriesSupplierCell = ({
  questions,
  supplierName,
}: ReviewEntriesSupplierCellProps): ReactElement => {
  const { t } = useTranslation()
  const isNewSupplier = hasThirdPartyQuestion(questions)

  if (!supplierName) {
    return <>{DEFAULT_NULL_REPLACEMENT_VALUE}</>
  }

  return (
    <Styled.ReviewEntriesSupplierCellWrapper>
      <Styled.ReviewEntriesSupplierName>{supplierName}</Styled.ReviewEntriesSupplierName>
      {isNewSupplier ? (
        <Styled.ReviewEntriesSupplierTagWrapper>
          <Tag color="purple" size="xs" type="subtle">
            {t('review_entries.table.new_supplier_tag')}
          </Tag>
        </Styled.ReviewEntriesSupplierTagWrapper>
      ) : null}
    </Styled.ReviewEntriesSupplierCellWrapper>
  )
}
